var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader"}},[_c('v-progress-circular',{attrs:{"size":"80","indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }